import React from "react";
import Register from "./Register";

const RegisterDriver = () => {
	return <Register type="driver" />;
};

export default RegisterDriver;
